import { render, staticRenderFns } from "./FieldHeader.vue?vue&type=template&id=85b7ff0e&"
import script from "./FieldHeader.vue?vue&type=script&lang=ts&"
export * from "./FieldHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FieldHeader.vue?vue&type=style&index=0&id=85b7ff0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports